import { BiMenu } from "react-icons/bi";
import { useState } from "react";
import { Bounce, toast, ToastContainer } from "react-toastify";

import { useLocation, useNavigate } from "react-router-dom";

import { useContextHook } from "../../../Context/ContextOpen";
import ButtonRed from "../../Buttons/Buttonred";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Search from "../../Search/Search";
import Profile from "../../Profile/Profile";
import { useLogout } from "../../../ApiS";
import { Loader } from "lucide-react";

interface NavbarProps {}

const Navbar: React.FC<NavbarProps> = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  const navigate = useNavigate();
  const {
    mutate: logout,
    isError,
    isLoading,
  } = useLogout(() => notify("خطأ في تسجيل الخروج"));

  const { changeMenu } = useContextHook();
  const [sure, setSure] = useState(false);
  const { pathname } = useLocation();
  // console.log(sure);

  return (
    <>
      {sure && (
        <>
          <ToastContainer />
          {isLoading ? <Loader /> : ""}
          <div
            className="fixed top-0 left-0  h-[105px]   !z-50"
            onClick={() => setSure(false)}
          ></div>
          <div
            className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-2 border-Third   rounded-3xl !z-50 flex justify-center items-center max-sm:w-full`}
          >
            <div className="bg-slate-50 !z-50 rounded-3xl w-[400px] max-w-[500px] min-h-[200px]">
              <p className="font-semibold text-xl text-center py-7">
                هل انت متأكد من تسجيل الخروج ؟
              </p>
              <div className="flex items-center justify-center gap-3 m-5">
                <ButtonRed
                  className="py-3 !px-"
                  onClick={() => {
                    logout("admin/logout");
                    setSure(false);
                  }}
                  name="نعم"
                />
                <ButtonRed
                  className="mx-2  !px-2  font-semibold border-2 border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white rounded-xl ml-5"
                  onClick={() => setSure(false)}
                  name=" إلغاء"
                />
              </div>
            </div>
          </div>
        </>
      )}
      <Row className="container mx-auto sticky w-[100%] bg-white top-0 !z-50 h-[70px] border-b-2  pt-2 flex-wrap mb-5 pb-2  border-[#D9D9D9] flex justify-between items-center">
        <Col col={3} xs={2} className="!mt-2 flex justify-center">
          <BiMenu
            size={35}
            className="text-[#777777] cursor-pointer lg:mx-8 max-lg:mx-3 max-md:mx-0"
            onClick={changeMenu}
          />
        </Col>

        {/* <Col col={6} xs={7} className=" !mt-2 flex justify-center ">
          <Search placeholder="بحث" />
        </Col> */}

        <Col col={3} xs={3} className=" ">
          <div className="  !mt-2 flex justify-center  ">
            <Profile setSure={setSure} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Navbar;
